import * as React from 'react';
import * as styles from './ContactsBlock.css';

interface IContactsBlockProps {
  contact: React.ReactNode;
  controls: React.ReactNode;
  favorite: React.ReactNode;
  link: React.ReactNode;
}

export function ContactsBlock({ contact, controls, favorite, link }: IContactsBlockProps) {
  return (
    <div data-testid="ContactsBlock" className={styles['container']}>
      <div className={styles['left-column']}>
        <div className={styles['contact']}>
          {contact}
          {controls}
        </div>
        <div>{link}</div>
      </div>
      <div className={styles['favorite']}>{favorite}</div>
    </div>
  );
}
